import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';

@Injectable()
export class ReceiptService extends BaseApiService {
    // Gets the receipt information
    public getReceiptForCart(businessTransactionCartId: number) {
        return this.get(`Finance/Receipt/Cart/${businessTransactionCartId}`);
    }

    // Gets the receipt payment details for the specified cash drawer and payment method type
    public getReceiptPaymentDetails(cashDrawerId: number, paymentMethodTypeId: number) {
        return this.get(`Finance/Receipt/CashDrawer/${cashDrawerId}/PaymentMethodType/${paymentMethodTypeId}`);
    }

    // Gets the receipt payments for the given receipt number
    public getReceiptPayments(receiptId: number) {
        return this.get(`Finance/Receipt/${receiptId}/Payments`);
    }

    // Gets the receipt document
    public getReceiptDocument(receiptId: number) {
        return this.get(`Finance/Receipt/${receiptId}/Document`);
    }
}
